const isPlainObject = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" &&
	value !== null &&
	!Array.isArray(value) &&
	(Object.getPrototypeOf(value) === Object.prototype ||
		Object.getPrototypeOf(value) === null);

const hasDirtyField = (dirty: unknown): boolean => {
	if (Array.isArray(dirty)) return dirty.some(hasDirtyField);
	if (isPlainObject(dirty)) return Object.values(dirty).some(hasDirtyField);

	return dirty === true;
};

export const getFormValuesDiff = <TInput, TOutput>(
	dirtyFields: unknown,
	currentValues: TOutput,
	inputValues?: unknown,
): Partial<Pick<TOutput, keyof TInput & keyof TOutput>> => {
	if (!isPlainObject(dirtyFields) || !isPlainObject(currentValues)) return {};

	const result: Record<string, unknown> = {};
	let hasTransformedField = false;

	for (const key of Object.keys(dirtyFields)) {
		if (!(key in currentValues)) {
			hasTransformedField = true;
			continue;
		}

		const dirty = dirtyFields[key];
		const value = currentValues[key];

		if (!hasDirtyField(dirty)) continue;

		if (isPlainObject(dirty) && isPlainObject(value)) {
			result[key] = getFormValuesDiff(dirty, value);
		} else {
			result[key] = value;
		}
	}

	// TODO(DEV-3865): once a second form transforms an input field into other output keys (like building amenities), replace this heuristic with explicit `derivedFields` in useEditPortfolioForm, required by type whenever the schema drops an input key.
	if (hasTransformedField && isPlainObject(inputValues)) {
		for (const key of Object.keys(currentValues)) {
			if (!(key in inputValues)) {
				result[key] = currentValues[key];
			}
		}
	}

	return result as Partial<Pick<TOutput, keyof TInput & keyof TOutput>>;
};
